export const OK = 200
export const BAD_REQUEST = 400
export const NOT_FOUND = 404
export const CONFLICT = 409
export const PRECONDITION_UNMET = 412
export const UNAUTHORIZED = 403
export const SERVER_ERROR = 500
export const BAD_GATEWAY = 502

// -- API Status Code Helpers

export const isGoodResponse = (status) => status >= 200 && status < 400
export const isBadResponse = (status) => status >= 400
